export const getMonthName = (monthNumber: number | string) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const startMonth = monthNames[Number(monthNumber) - 1];
  const endMonth = monthNames[(Number(monthNumber) + 10) % 12];

  return { startMonth, endMonth };
};

export const getMonthNameWithNumber = (monthNumber: number): string => {
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Adjust for zero-based index (JavaScript months start from 0, we need 1-based)
  if (monthNumber < 1 || monthNumber > 12) {
    throw new Error('Invalid month number. Must be between 1 and 12.');
  }

  return `${monthNames[monthNumber - 1]}`;
};
